import React, { Suspense, useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { routes } from './routes';
import { MainContainer } from './MainContainer';
import Loading from '../components/Loading';
import { useAppInitiate } from '../hooks/useAppInitiate';
import { Text } from '../components/Element';
import { AccountLoadRetry, AccountSetupUnresolved } from './screen/Auth/subcomponents/AccountStatus/AccountStatus';

export const Screens = () => {
  const { error, isUserAuthenticated, isLoading, loadFailed, retryLoad, setupMarker } = useAppInitiate();

  if (isLoading) {
    return <Loading fullscreen={true} />;
  }

  // Rendered on any URL, in place of the routes and before any redirect.
  if (setupMarker) {
    return <AccountSetupUnresolved marker={setupMarker} />;
  }

  if (loadFailed) {
    return <AccountLoadRetry onRetry={retryLoad} />;
  }

  if (error) {
    return <Text>Oops, Something went wrong</Text>;
  }

  return (
    <MainContainer fullscreen={!isUserAuthenticated}>
      <Routes>
        {routes.map((item) => {
          return <Route path={item.path} Component={item.Component} key={item.path} />;
        })}
      </Routes>
    </MainContainer>
  );
};

export default Screens;
